import { Divider, Flex, Spacing } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

import { CardFooter } from './elements/CardFooter'
import { CardHeader } from './elements/CardHeader'
import * as Styled from './styles'

interface IntegrationCardProps {
  children: ReactNode
}

export const IntegrationCard = ({ children }: IntegrationCardProps): ReactElement => {
  return (
    <Styled.IntegrationCardWrapper>
      <Flex flexDirection="column" gap={Spacing.S16}>
        {children}
      </Flex>
    </Styled.IntegrationCardWrapper>
  )
}

IntegrationCard.Header = CardHeader
IntegrationCard.Divider = Divider
IntegrationCard.Footer = CardFooter
